export const SPECIAL_SCREENS = ['teaser', 'fragmentRedirect', 'overlayScreen', 'browserPermission'];
export const EMBEDDABLE_SIDEBAR_STRUCTURES = ['question', 'topic', 'article', 'simple-comments'];
